<template>
  <div class="users-education">
    <h1 class="users-education__title">Обучение. Базовый курс</h1>
    <el-row>
      <el-col>
        <h2 class="users-education__subtitle">основные задания</h2>
      </el-col>
      <el-col>
        <swiper class="swiper" :options="swiperOptionMain">
          <swiper-slide v-for="item in mainAssignments" :key="item.id">
            <MainCard :item="item" />
          </swiper-slide>
        </swiper>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <h2 class="users-education__subtitle">Дополнительные задания. День 2</h2>
      </el-col>
      <el-col>
        <swiper class="swiper" :options="swiperOptionAdditional">
          <swiper-slide v-for="item in additionalAssignments" :key="item.id">
            <AdditionalCard :item="item" />
          </swiper-slide>
        </swiper>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import MainCard from '@/components/Users/Education/MainCard'
import AdditionalCard from '@/components/Users/Education/AdditionalCard'

export default {
  name: 'Education',
  components: {
    Swiper,
    SwiperSlide,
    MainCard,
    AdditionalCard
  },
  data: () => ({
    mainAssignments: [
      {
        id: 1,
        number: 1,
        content: 'А, О, У, Э, И',
        points: 80,
        type: 'letters',
        status: 2
      },
      {
        id: 2,
        number: 2,
        content: 'А, О, У, Э, И',
        points: 80,
        type: 'test',
        status: 1
      },
      {
        id: 3,
        number: 3,
        content: 'А, О, У, Э, И',
        points: 100,
        type: 'content',
        status: 0
      },
      {
        id: 4,
        number: 4,
        content: 'А, О, У, Э, И',
        points: 100,
        type: 'material',
        status: 0
      }
    ],

    additionalAssignments: [
      {
        id: 1,
        number: 1,
        content: 'М, П, Б, Н, Т, Д, К, Г, Х, Р ',
        points: 80,
        type: 'letters',
        status: 2
      },
      {
        id: 2,
        number: 2,
        content: 'М, П, Б, Н, Т, Д, К, Г, Х, Р',
        points: 80,
        type: 'test',
        status: 1
      },
      {
        id: 3,
        number: 3,
        content: 'А, О, У, Э, И',
        points: 100,
        type: 'content',
        status: 0
      },
      {
        id: 4,
        number: 4,
        content: 'А, О, У, Э, И',
        points: 100,
        type: 'material',
        status: 0
      },
      {
        id: 5,
        number: 5,
        content: 'А, О, У, Э, И',
        points: 100,
        type: 'material',
        status: 0
      },
      {
        id: 6,
        number: 6,
        content: 'А, О, У, Э, И',
        points: 100,
        type: 'material',
        status: 0
      }
    ],

    swiperOptionMain: {
      slidesPerView: 3,
      spaceBetween: 16,
      breakpoints: {
        1440: {
          slidesPerView: 3
        },
        1024: {
          slidesPerView: 2
        },
        768: {
          slidesPerView: 2
        },
        600: {
          slidesPerView: 1
        },
        320: {
          slidesPerView: 1
        }
      }
    },

    swiperOptionAdditional: {
      slidesPerView: 4,
      spaceBetween: 16,
      breakpoints: {
        1440: {
          slidesPerView: 4
        },
        1024: {
          slidesPerView: 3
        },
        768: {
          slidesPerView: 2
        },
        600: {
          slidesPerView: 1
        },
        320: {
          slidesPerView: 1
        }
      }
    }
  }),

  methods: {}
}
</script>

<style scoped lang="scss">
.users-education {
  &__title {
    font-weight: bold;
    font-size: 24px;
    letter-spacing: 0.35px;
    color: $luchmara;
  }

  &__subtitle {
    margin-top: 48px;
    margin-bottom: 16px;
    font-weight: 500;
    font-size: 13px;
    letter-spacing: 0.2px;
    text-transform: uppercase;
    color: $french-gray;

    @include md-and-down {
      margin-top: 32px;
    }
  }
}
</style>
